/**
 * @overview RouterProvider wrapper that takes router props and exposes them via context
 */

import React from 'react'
import { withRouter, WithRouterProps } from 'react-router'
import RouterContext from './context'

// Instead of wrapping <RouterProvider> in `withRouter` and potentially overriding
// props unintenionally, use this render-prop component to expose only `router`
const ExposeRouter: React.FC<WithRouterProps> = ({ children, router }) => {
  return typeof children === 'function' ? children({ router }) : children
}

const WrappedExposeRouter: React.FC = withRouter(ExposeRouter)

const RouterProvider: React.FC = ({ children, ...props }) => (
  <WrappedExposeRouter>
    {({ router }) => (
      <RouterContext.Provider value={{ router }}>
        {React.isValidElement(children) ? React.cloneElement(children, props) : children}
      </RouterContext.Provider>
    )}
  </WrappedExposeRouter>
)

export default RouterProvider
